var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-6" },
      [
        _c(
          "FormWrapper",
          [
            _c(
              "FormControl",
              [
                _c("FormLabel", { attrs: { for: "name" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("remoteMonitoring.procedures.form.name")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("FormInput", {
                  attrs: { id: "name" },
                  model: {
                    value: _vm.model.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "name", $$v)
                    },
                    expression: "model.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "UiCompletionCard",
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center mb-2 gap-2" },
                  [
                    _c("UiCompletionStepper", {
                      attrs: {
                        steps: _vm.channelsRules.stepper.steps,
                        current: _vm.channelsRules.stepper.current,
                        status: _vm.channelsRules.stepper.status,
                      },
                    }),
                    _vm._v(" "),
                    _c("strong", { staticClass: "ml-2" }, [
                      _vm.channelsRules.stepper.status === "danger"
                        ? _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "remoteMonitoring.procedures.completion.status_danger"
                                )
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.channelsRules.stepper.status === "warning"
                        ? _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "remoteMonitoring.procedures.completion.status_warning"
                                )
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.channelsRules.stepper.status === "success"
                        ? _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "remoteMonitoring.procedures.completion.status_success"
                                )
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "UiCompletionList",
                  [
                    _c(
                      "UiCompletionLine",
                      {
                        attrs: {
                          is_completed: _vm.channelsRules.hasMobile,
                          is_required: _vm.channelsRules.hasChannels,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "remoteMonitoring.procedures.completion.has_mobile"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "UiCompletionLine",
                      {
                        attrs: { is_completed: _vm.channelsRules.hasLengthMin },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "remoteMonitoring.procedures.completion.has_length_min"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "UiCompletionLine",
                      {
                        attrs: {
                          is_completed:
                            _vm.channelsRules.hasLengthMinRecommended,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "remoteMonitoring.procedures.completion.has_length_min_reco"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "FormControl",
              [
                _c(
                  "FormLabel",
                  { attrs: { for: "channels" } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("remoteMonitoring.procedures.form.contacts")
                        ) +
                        "\n          "
                    ),
                    _c(
                      "UiBadge",
                      {
                        staticClass: "text-mono ml-2 rounded-full",
                        attrs: {
                          type: _vm.model.channels.length
                            ? "secondary"
                            : "danger",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.model.channels.length) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("FormHelper", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("remoteMonitoring.procedures.form.contacts_info")
                    ),
                  },
                }),
                _vm._v(" "),
                _c("ChannelMultiselect", {
                  staticClass: "multiselect-with-index",
                  attrs: {
                    channelType: "phone,mobile",
                    maxChannels: 4,
                    channelValidated: true,
                  },
                  model: {
                    value: _vm.model.channels,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "channels", $$v)
                    },
                    expression: "model.channels",
                  },
                }),
                _vm._v(" "),
                _vm.channelsRules.hasUniquesInfo === false
                  ? _c("FormError", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t(
                            "remoteMonitoring.procedures.form.contacts_errors_duplicate"
                          )
                        ),
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-6" },
      [
        _c(
          "FormWrapper",
          [
            _c(
              "FormControl",
              [
                _c(
                  "FormLabel",
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("remoteMonitoring.procedures.form.devices")
                        ) +
                        "\n          "
                    ),
                    _c(
                      "UiBadge",
                      {
                        staticClass: "text-mono ml-2 rounded-full",
                        attrs: {
                          type: _vm.model.datis.length ? "secondary" : "danger",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.model.datis.length) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("FormHelper", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("remoteMonitoring.procedures.form.devices_info")
                    ),
                  },
                }),
                _vm._v(" "),
                _c("SelectList", {
                  attrs: {
                    list: _vm.availableDevices,
                    itemType: "datiMonitoring",
                    messages: _vm.messages,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }